import { clearErrorMsg } from '../appStore/commonSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

interface HistoryListenerProps {
  children: React.ReactNode;
}

const HistoryListener: React.FC<HistoryListenerProps> = ({ children }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    return history.listen((location) => {
      dispatch(clearErrorMsg());
    });
  }, [dispatch, history]);

  return <>{children}</>;
};

export default HistoryListener;
